/* eslint-disable react-hooks/exhaustive-deps */
import * as yup from "yup";

import { Button, Grid } from "@mui/material";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import CloseIcon from "@mui/icons-material/Close";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import IconButton from "@mui/material/IconButton";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { LoadingButton } from "@mui/lab";

import TextInput from "../../../../components/hookForms/textField";
import messages from "../../../../utils/messages";
import serviceBonificacao from "@/services/serviceBonificacao";
import InputNumber from "@/components/hookForms/inputNumber";

export interface IDialogProps {
    open: boolean;
    onSuccess: () => void;
    data: {
        open: boolean;
        bonificacaoID: string;
        nomeCliente: string;
        instalacaoID: string;
        tipo: string;
        quantidadeBonus: string;
        quantidadeFaturas: string;
        restante: string;
        observacao: string;
        dataInicio: string;
        numeroInstalacao: string;
        dataHoraUltimaAtualizacao: string;
    };
    onClose?: any;
}

export default function DialogEdit({ open, data, onClose, onSuccess }: IDialogProps) {
    const [isDisable, setDisable] = useState(false);
    const [isLoading, setLoading] = useState(false);

    const validationSchema = yup.object().shape({
        restante: yup.string().required(messages.requiredField).typeError(messages.requiredField),
        observacao: yup.string().required(messages.requiredField),
    });

    const {
        control,
        handleSubmit,
        reset,
        formState: { errors },
        // eslint-disable-next-line react-hooks/rules-of-hooks
    } = useForm({
        resolver: yupResolver(validationSchema),
        defaultValues: {
            nomeCliente: "",
            instalacaoID: "",
            tipo: "",
            quantidadeBonus: "",
            quantidadeFaturas: "",
            restante: "",
            observacao: "",
            dataInicio: "",
            numeroInstalacao: "",
            dataHoraUltimaAtualizacao: "",
        },
    });

    useEffect(() => {
        if (data) {
            reset(data);
        }
    }, [data]);

    const onSubmit = (values: any) => {
        setDisable(true);
        setLoading(true);

        const updateValues = {
            ...values,
            restante: values.restante ? Number(values.restante.replaceAll(".", "").replaceAll(",", ".")) : 0,
        };

        serviceBonificacao
            .update(updateValues)
            .then((result) => {
                if (result) {
                    toast.success(messages.updateSucess);
                    onClose(true);
                    onSuccess();
                }
            })
            .catch((err) => {
                toast.error(messages.updateError, err);
            })
            .finally(() => {
                setDisable(false);
                setLoading(false);
            });
    };
    return (
        <Dialog
            maxWidth="md"
            fullWidth
            onClose={(_, reason) => {
                if (reason !== "backdropClick") {
                    onClose();
                }
            }}
            open={open}
        >
            <form onSubmit={handleSubmit(onSubmit)}>
                <DialogTitle>
                    Editar
                    <IconButton
                        aria-label="close"
                        onClick={() => {
                            reset();
                            onClose(true);
                        }}
                        sx={{
                            position: "absolute",
                            right: 8,
                            top: 8,
                            color: (theme) => theme.palette.grey[500],
                        }}
                    >
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                <DialogContent dividers>
                    <Grid container spacing={1}>
                        <Grid item xs={12} md={6}>
                            <TextInput
                                id="cliente"
                                name="nomeCliente"
                                label="Cliente"
                                control={control}
                                disabled={true}
                            />
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <TextInput
                                id="instalacao"
                                name="instalacaoID"
                                label="Instalação"
                                control={control}
                                disabled={true}
                            />
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <TextInput id="tipo" name="tipo" label="Tipo" control={control} disabled={true} />
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <TextInput
                                id="quantidadeBonus"
                                name="quantidadeBonus"
                                label="Qtd Bônus"
                                control={control}
                                disabled={true}
                            />
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <TextInput
                                id="quantidadeFaturas"
                                name="quantidadeFaturas"
                                label="Qtd Faturas"
                                control={control}
                                disabled={true}
                            />
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <InputNumber
                                name="restante"
                                label="Restante"
                                control={control}
                                error={errors}
                                decimalScale={2}
                            />
                        </Grid>
                        <Grid item md={12} xs={12}>
                            <TextInput
                                id="observacao"
                                name="observacao"
                                label="Observação"
                                control={control}
                                error={errors}
                            />
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions style={{ display: "flex", justifyContent: "center", margin: "24px" }}>
                    <Button
                        onClick={onClose}
                        color="warning"
                        variant="contained"
                        style={{ width: "159px", height: "44px" }}
                    >
                        Cancelar
                    </Button>
                    <LoadingButton
                        type="submit"
                        color="primary"
                        variant="contained"
                        loading={isLoading}
                        disabled={isDisable}
                        style={{ width: "159px", height: "44px" }}
                    >
                        Salvar
                    </LoadingButton>
                </DialogActions>
            </form>
        </Dialog>
    );
}
